/* Amryth story sections: scroll reveals + scroll-driven timeline (progresses down, retracts up) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(selector) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function headerOffset() {
    var h = document.querySelector('sticky-header, .header-wrapper');
    var px = h ? h.getBoundingClientRect().height : 96;
    document.documentElement.style.setProperty('--am-header-offset', Math.round(px) + 'px');
  }

  function timeline() {
    var track = document.querySelector('.tl__track');
    if (!track || track.dataset.tlReady) return;
    track.dataset.tlReady = '1';
    var stops = Array.prototype.slice.call(track.querySelectorAll('.tl__stop'));
    headerOffset();
    window.addEventListener('resize', headerOffset);
    if (reduce) {
      track.style.setProperty('--tl-progress', 1);
      stops.forEach(function (s) { s.classList.add('is-in'); });
      return;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      // The tip of the drawn line is pinned to 68% of the viewport height: it grows as you scroll down and retracts as you scroll up.
      var inset = parseFloat(getComputedStyle(track, '::after').top) || 16;
      // the line ends at the LAST dot's center, not at the bottom of the last stop's text
      var last = stops[stops.length - 1], end = inset;
      if (last) { var dcs = getComputedStyle(last, '::before'); end = r.height - (last.offsetTop + (parseFloat(dcs.top) || 8) + (parseFloat(dcs.height) || 16) / 2); track.style.setProperty('--tl-end', end.toFixed(1) + 'px'); }
      var lineLen = Math.max(r.height - inset - end, 1);
      var reach = Math.max(0, Math.min(lineLen, vh * 0.68 - r.top - inset));
      track.style.setProperty('--tl-progress', (reach / lineLen).toFixed(3));
      // A stop lights once the line has reached its dot and dims again when the line retracts above it.
      var tip = reach + inset;
      stops.forEach(function (s) {
        var cs = getComputedStyle(s, '::before');
        var dotY = s.offsetTop + (parseFloat(cs.top) || 8) + (parseFloat(cs.height) || 16) / 2;
        s.classList.toggle('is-in', tip >= dotY - 1);
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // Generic horizontal scroller: [data-scroll-track] + [data-scroll-prev]/[data-scroll-next] (also the reviews' data-rv-* attrs)
  function scrollers() {
    document.querySelectorAll('[data-scroll-track], .rv__track').forEach(function (track) {
      if (track.dataset.ready) return;
      track.dataset.ready = '1';
      var sec = track.closest('section') || document;
      var prev = sec.querySelector('[data-scroll-prev], [data-rv-prev]'), next = sec.querySelector('[data-scroll-next], [data-rv-next]');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + gap : 300; }
      function upd() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function versus() {
    document.querySelectorAll('.vs').forEach(function (sec) {
      var table = sec.querySelector('.vs__table'); if (!table || table.dataset.ready) return;
      table.dataset.ready = '1';
      sec.querySelectorAll('[data-vs-alt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          table.dataset.alt = btn.dataset.vsAlt;
          sec.querySelectorAll('[data-vs-alt]').forEach(function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        });
      });
    });
  }

  // Smooth <details> open/close (FAQ pills, buybox accordions)
  function accordions() {
    document.querySelectorAll('details.fq__item, details.ab__acc').forEach(function (det) {
      if (det.dataset.ready) return;
      det.dataset.ready = '1';
      var summary = det.querySelector('summary'), body = det.querySelector('.fq__a, .ab__acc__body');
      if (!summary || !body) return;
      body.style.overflow = 'hidden';
      var animating = false;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (animating || reduce) { if (reduce) det.open = !det.open; return; }
        animating = true;
        var cs = getComputedStyle(body), pt = cs.paddingTop, pb = cs.paddingBottom;
        var closed = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
        if (det.open) {
          var opened = { height: body.getBoundingClientRect().height + 'px', paddingTop: pt, paddingBottom: pb, opacity: 1 };
          var a = body.animate([opened, closed], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
          a.onfinish = function () { det.open = false; a.cancel(); animating = false; };
        } else {
          det.open = true;
          var target = { height: body.getBoundingClientRect().height + 'px', paddingTop: pt, paddingBottom: pb, opacity: 1 };
          var b = body.animate([closed, target], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
          b.onfinish = function () { animating = false; };
        }
      });
    });
  }

  // Ingredient tabs (mobile): tabs scroll the panel row; swiping the row updates the active tab.
  function ingredientTabs() {
    document.querySelectorAll('.ig').forEach(function (sec) {
      var tabs = sec.querySelectorAll('[data-ig-tab]'), track = sec.querySelector('.ig__panels');
      if (!tabs.length || !track || sec.dataset.tabsReady) return;
      sec.dataset.tabsReady = '1';
      var panels = track.querySelectorAll('[data-ig-panel]');
      function setActive(n) { tabs.forEach(function (t) { var on = t.dataset.igTab === String(n); t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var n = parseInt(tab.dataset.igTab, 10), p = panels[n - 1]; if (!p) return;
          setActive(n);
          track.scrollTo({ left: (n - 1) * p.getBoundingClientRect().width, behavior: 'smooth' });
        });
      });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var w = panels[0] ? panels[0].getBoundingClientRect().width : track.clientWidth;
          if (!w) return;
          setActive(Math.min(panels.length, Math.max(1, Math.round(track.scrollLeft / w) + 1)));
        }, 60);
      }, { passive: true });
    });
  }

  // UGC videos: muted autoplay only while on screen; tap toggles sound (and plays if paused).
  function ugc() {
    // Click-to-play (Javvy): posters at rest, tap plays WITH sound, one clip at a time, tap again pauses.
    document.querySelectorAll('[data-ug]').forEach(function (grid) {
      if (grid.dataset.ready) return;
      grid.dataset.ready = '1';
      var medias = grid.querySelectorAll('.ug__media');
      function stopOthers(keep) {
        medias.forEach(function (o) { if (o !== keep) { var ov = o.querySelector('video'); if (ov && !ov.paused) ov.pause(); } });
      }
      medias.forEach(function (m) {
        var v = m.querySelector('video'); if (!v) return;
        v.autoplay = false; v.loop = false;
        v.addEventListener('play', function () { m.classList.add('is-playing'); stopOthers(m); });
        v.addEventListener('pause', function () { m.classList.remove('is-playing'); });
        v.addEventListener('ended', function () { m.classList.remove('is-playing'); v.currentTime = 0; });
        m.addEventListener('click', function () {
          if (v.paused) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
          else { v.pause(); }
        });
      });
      // Speed (9/30): posters load only when the band is near the screen (a poster attribute downloads immediately and competed with the hero on slow phones).
      function showPosters() { medias.forEach(function (m) { var v = m.querySelector('video'); if (v && v.dataset.poster && !v.poster) v.poster = v.dataset.poster; }); }
      if ('IntersectionObserver' in window) {
        var po = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { showPosters(); po.disconnect(); }
        }, { rootMargin: '800px 0px' });
        po.observe(grid);
      } else { showPosters(); }
      // Pause anything that scrolls off screen
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { var v = en.target.querySelector('video'); if (v && !en.isIntersecting && !v.paused) v.pause(); });
        }, { threshold: 0.2 });
        medias.forEach(function (m) { io.observe(m); });
      }
    });
  }
  function boot() { timeline(); scrollers(); versus(); accordions(); ingredientTabs(); ugc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
